import styled from 'styled-components';

export const PaginationList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const PaginationButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  border: 1px solid #f1f1f1;
  background: var(--white);
  transition: all ease-in-out 0.3s;

  &:hover,
  &.active {
    color: var(--white);
    background: var(--blue);

    .icon {
      color: var(--white);
    }
  }

  .icon {
    display: block;
    font-size: 16px;
    line-height: 1;
    color: rgba(49, 49, 49, 1);

    &.duble {
      font-size: 22px;
    }
  }
`;
